import { STEP } from "./steps";

export const RESUME = {
  fuelRequirements: "fuelRequirements",
  companyRole: "companyRole",
  goals: "goals",
  procurement: "procurement",
  operations: "operations",
  dieselScore: "dieselScore",
};

/**
 * Single source for resume targets: history under the landing step, and which
 * loader the new-customer `resume` action should run.
 *
 * `when` predicates are evaluated top-down in `resolveResumeTarget`.
 */
export const RESUME_REGISTRY = [
  // Score / assessment resumes land on a single step so Back cannot open an
  // empty prior score card (no assessment payload was loaded for that step).
  {
    target: RESUME.dieselScore,
    when: (s) => Boolean(s.is_completed),
    baseHistory: [STEP.dieselScore],
    load: "dieselScore",
  },
  {
    target: RESUME.operations,
    when: (s) =>
      Boolean(s.procurement_completed) && !s.operations_completed,
    baseHistory: [STEP.operationsScore],
    load: "operations",
  },
  {
    target: RESUME.procurement,
    when: (s) =>
      Boolean(s.onboarding_completed || s.step_3_completed) &&
      !s.procurement_completed,
    baseHistory: [STEP.procurementScore],
    load: "procurement",
  },
  {
    target: RESUME.goals,
    when: (s) => Boolean(s.step_2_completed),
    baseHistory: [STEP.fuelRequirements],
    load: "goals",
  },
  {
    target: RESUME.companyRole,
    when: (s) => Boolean(s.step_1_completed),
    baseHistory: [STEP.fuelRequirements],
    load: "companyRole",
  },
  {
    target: RESUME.fuelRequirements,
    when: (s) => Boolean(s.registration_completed),
    baseHistory: [STEP.fuelRequirements],
    load: "fuelRequirements",
  },
];

/** Empty / unrecognized step_status → fuel requirements (not procurement). */
export const DEFAULT_RESUME_TARGET = RESUME.fuelRequirements;

const entryByTarget = Object.fromEntries(
  RESUME_REGISTRY.map((entry) => [entry.target, entry]),
);

export const resumeEntry = (target) =>
  entryByTarget[target] || entryByTarget[RESUME.procurement];

export const resumeBaseHistory = (target) =>
  resumeEntry(target).baseHistory;

export const resumeLabel = (target) => {
  if (target === RESUME.operations) {
    return "Operations";
  }
  return "Procurement";
};

export const resolveResumeTargetFromStatus = (stepStatus = {}) => {
  if (!stepStatus || typeof stepStatus !== "object") {
    return DEFAULT_RESUME_TARGET;
  }
  for (const entry of RESUME_REGISTRY) {
    if (entry.when(stepStatus)) {
      return entry.target;
    }
  }
  return DEFAULT_RESUME_TARGET;
};
